function forEach(array, callback, scope) {
  for (let index = 0; index < array.length; index += 1) {
    callback.call(scope, array[index], index);
  }
}

export default forEach;
